import React from 'react'
import { DrawerProps } from "antd/lib/drawer"
import { Drawer as DrawerExt } from "antd"
import { omit } from 'lodash'
import { defaultProps } from '@config/antd.config'
import DrawerViewJSONProvider, { useDrawerViewJSON } from './ViewJson/provider'

type TExtendDrawerProps = DrawerProps & {
  children: React.ReactNode
}

let drawerOpenCount = 0

export const Drawer = (props: TExtendDrawerProps) => {
  const drawerProps = omit(props, 'children')


  // useEffect(() => {
  //   if (props.visible) {
  //     drawerOpenCount += 1;

  //     const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

  //     document.body.style.overflow = 'hidden';
  //     document.body.style.paddingRight = `${scrollbarWidth}px`;
  //   }

  //   return () => {
  //     if (props.visible) {
  //       drawerOpenCount--
  //       if (drawerOpenCount === 0) document.body.style.overflow = '';
  //     }

  //   };
  // }, [props.visible]);

  const handleAfterOpenChange = (open: boolean) => {
    if (open) {
      drawerOpenCount += 1;

      // Áp dụng ngay để tránh layout shift
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    } else {
      drawerOpenCount -= 1;
      if (drawerOpenCount <= 0) {
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
      }
    }
  }

  return <DrawerExt afterVisibleChange={handleAfterOpenChange} {...defaultProps.drawer} {...drawerProps}>
    {props.children}
  </DrawerExt>
}


Drawer.useDrawerViewJSON = useDrawerViewJSON
Drawer.ViewJSONProvider = DrawerViewJSONProvider
